import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.407.195a1 1 0 0 1 1.186 0l8.779 6.464A4 4 0 0 1 23 9.88V20.5a3.5 3.5 0 0 1-3.5 3.5H16a2 2 0 0 1-2-2v-5.5h-4V22a2 2 0 0 1-2 2H4.5A3.5 3.5 0 0 1 1 20.5V9.88a4 4 0 0 1 1.628-3.22l8.78-6.465ZM12 2.242 3.814 8.27A2 2 0 0 0 3 9.88V20.5A1.5 1.5 0 0 0 4.5 22H8v-6a1.5 1.5 0 0 1 1.5-1.5h5A1.5 1.5 0 0 1 16 16v6h3.5a1.5 1.5 0 0 0 1.5-1.5V9.88a2 2 0 0 0-.814-1.61L12 2.242Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
